// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/vault/v1/vault.proto" (package "c1.api.vault.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { User } from "../../user/v1/user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Duration } from "../../../../google/protobuf/duration";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.vault.v1.VaultOpenerServiceOpenRequest
 */
export interface VaultOpenerServiceOpenRequest {
    /**
     * @generated from protobuf field: string vault_id = 1;
     */
    vaultId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string credential_id = 4;
     */
    credentialId: string;
    /**
     * public key should be a JWK storing a ECDSA public key.
     *
     * @generated from protobuf field: bytes reader_public_key = 5;
     */
    readerPublicKey: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultOpenerServiceOpenResponse
 */
export interface VaultOpenerServiceOpenResponse {
    /**
     * Returns a compact JWE encrypted to the reader's public key.
     *
     * @generated from protobuf field: string encrypted_credential = 1;
     */
    encryptedCredential: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBinding
 */
export interface AppVaultBinding {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2;
     */
    vaultId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateRequest
 */
export interface AppVaultBindingServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2;
     */
    vaultId: string;
    /**
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBindingExpandMask expand_mask = 3;
     */
    expandMask?: AppVaultBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateResponse
 */
export interface AppVaultBindingServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBindingView app_vault_binding_view = 1;
     */
    appVaultBindingView?: AppVaultBindingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteRequest
 */
export interface AppVaultBindingServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2;
     */
    vaultId: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteResponse
 */
export interface AppVaultBindingServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceListRequest
 */
export interface AppVaultBindingServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBindingExpandMask expand_mask = 4;
     */
    expandMask?: AppVaultBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceListResponse
 */
export interface AppVaultBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.AppVaultBindingView list = 1;
     */
    list: AppVaultBindingView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingRef
 */
export interface AppVaultBindingRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2;
     */
    vaultId: string;
}
/**
 * The AppUserExpandMask message contains a list of paths to expand in the response.
 *
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingExpandMask
 */
export interface AppVaultBindingExpandMask {
    /**
     * The paths to expand in the response. May be any combination of "*", "app_id", and "vault_id".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * The AppVaultBindingView contains an app vault binding as well as paths for apps and vaults in expanded arrays.
 *
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingView
 */
export interface AppVaultBindingView {
    /**
     * The AppVaultBinding included in this request.
     *
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBinding app_vault_binding = 1;
     */
    appVaultBinding?: AppVaultBinding;
    /**
     * JSONPATH expression indicating where the app is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating where the vault is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string vault_path = 3;
     */
    vaultPath: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultRef
 */
export interface VaultRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.GroupAuthzVault
 */
export interface GroupAuthzVault {
}
/**
 * @generated from protobuf message c1.api.vault.v1.MagicVault
 */
export interface MagicVault {
    /**
     * @generated from protobuf field: uint32 allowed_views = 1;
     */
    allowedViews: number;
    /**
     * @generated from protobuf field: bool allow_unauthed_views = 2;
     */
    allowUnauthedViews: boolean;
}
/**
 * @generated from protobuf message c1.api.vault.v1.Vault
 */
export interface Vault {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 6;
     */
    description: string;
    /**
     * Expiration duration for credentials in this vault.
     *
     * @generated from protobuf field: google.protobuf.Duration credential_expiration_duration = 7;
     */
    credentialExpirationDuration?: Duration;
    /**
     * @generated from protobuf oneof: vault
     */
    vault: {
        oneofKind: "groupAuthzVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.GroupAuthzVault group_authz_vault = 100;
         */
        groupAuthzVault: GroupAuthzVault;
    } | {
        oneofKind: "magicVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.MagicVault magic_vault = 101;
         */
        magicVault: MagicVault;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceCreateRequest
 */
export interface VaultServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 4;
     */
    ownerIds: string[];
    /**
     * @generated from protobuf oneof: vault
     */
    vault: {
        oneofKind: "groupAuthzVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.GroupAuthzVault group_authz_vault = 100;
         */
        groupAuthzVault: GroupAuthzVault;
    } | {
        oneofKind: "magicVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.MagicVault magic_vault = 101;
         */
        magicVault: MagicVault;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceCreateResponse
 */
export interface VaultServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1;
     */
    vault?: Vault;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetRequest
 */
export interface VaultServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetResponse
 */
export interface VaultServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1;
     */
    vault?: Vault;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceDeleteRequest
 */
export interface VaultServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.vault.v1.VaultServiceDeleteResponse
 */
export interface VaultServiceDeleteResponse {
}
/**
 * The VaultServiceUpdateRequest message contains the vault object to update and a field mask to indicate which fields to update.
 *
 * @generated from protobuf message c1.api.vault.v1.VaultServiceUpdateRequest
 */
export interface VaultServiceUpdateRequest {
    /**
     * The vault object with the changes to update.
     *
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1;
     */
    vault?: Vault;
    /**
     * The update mask is a comma-separated string of fields to update.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceUpdateResponse
 */
export interface VaultServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1;
     */
    vault?: Vault;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListRequest
 */
export interface VaultServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListResponse
 */
export interface VaultServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.Vault list = 1;
     */
    list: Vault[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListOwnersRequest
 */
export interface VaultServiceListOwnersRequest {
    /**
     * @generated from protobuf field: string vault_id = 1;
     */
    vaultId: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListOwnersResponse
 */
export interface VaultServiceListOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSetOwnersRequest
 */
export interface VaultServiceSetOwnersRequest {
    /**
     * @generated from protobuf field: string vault_id = 1;
     */
    vaultId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 2;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSetOwnersResponse
 */
export interface VaultServiceSetOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchRequest
 */
export interface VaultServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.VaultRef refs = 5;
     */
    refs: VaultRef[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchResponse
 */
export interface VaultServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.Vault list = 1;
     */
    list: Vault[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsRequest
 */
export interface VaultServiceGetUserCanViewVaultsRequest {
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsResponse
 */
export interface VaultServiceGetUserCanViewVaultsResponse {
    /**
     * @generated from protobuf field: bool has_any_vaults = 1;
     */
    hasAnyVaults: boolean;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerRequest
 */
export interface VaultServiceSearchVaultsForOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerResponse
 */
export interface VaultServiceSearchVaultsForOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.Vault list = 1;
     */
    list: Vault[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class VaultOpenerServiceOpenRequest$Type extends MessageType<VaultOpenerServiceOpenRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultOpenerServiceOpenRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "credential_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "reader_public_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultOpenerServiceOpenRequest
 */
export const VaultOpenerServiceOpenRequest = new VaultOpenerServiceOpenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultOpenerServiceOpenResponse$Type extends MessageType<VaultOpenerServiceOpenResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultOpenerServiceOpenResponse", [
            { no: 1, name: "encrypted_credential", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultOpenerServiceOpenResponse
 */
export const VaultOpenerServiceOpenResponse = new VaultOpenerServiceOpenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBinding$Type extends MessageType<AppVaultBinding> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBinding", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBinding
 */
export const AppVaultBinding = new AppVaultBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceCreateRequest$Type extends MessageType<AppVaultBindingServiceCreateRequest> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppVaultBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateRequest
 */
export const AppVaultBindingServiceCreateRequest = new AppVaultBindingServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceCreateResponse$Type extends MessageType<AppVaultBindingServiceCreateResponse> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceCreateResponse", [
            { no: 1, name: "app_vault_binding_view", kind: "message", T: () => AppVaultBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateResponse
 */
export const AppVaultBindingServiceCreateResponse = new AppVaultBindingServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceDeleteRequest$Type extends MessageType<AppVaultBindingServiceDeleteRequest> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteRequest
 */
export const AppVaultBindingServiceDeleteRequest = new AppVaultBindingServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceDeleteResponse$Type extends MessageType<AppVaultBindingServiceDeleteResponse> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteResponse
 */
export const AppVaultBindingServiceDeleteResponse = new AppVaultBindingServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceListRequest$Type extends MessageType<AppVaultBindingServiceListRequest> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppVaultBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceListRequest
 */
export const AppVaultBindingServiceListRequest = new AppVaultBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceListResponse$Type extends MessageType<AppVaultBindingServiceListResponse> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppVaultBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceListResponse
 */
export const AppVaultBindingServiceListResponse = new AppVaultBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingRef$Type extends MessageType<AppVaultBindingRef> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingRef
 */
export const AppVaultBindingRef = new AppVaultBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingExpandMask$Type extends MessageType<AppVaultBindingExpandMask> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "vault_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingExpandMask
 */
export const AppVaultBindingExpandMask = new AppVaultBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingView$Type extends MessageType<AppVaultBindingView> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingView", [
            { no: 1, name: "app_vault_binding", kind: "message", T: () => AppVaultBinding },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vault_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingView
 */
export const AppVaultBindingView = new AppVaultBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultRef$Type extends MessageType<VaultRef> {
    constructor() {
        super("c1.api.vault.v1.VaultRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultRef
 */
export const VaultRef = new VaultRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GroupAuthzVault$Type extends MessageType<GroupAuthzVault> {
    constructor() {
        super("c1.api.vault.v1.GroupAuthzVault", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.GroupAuthzVault
 */
export const GroupAuthzVault = new GroupAuthzVault$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MagicVault$Type extends MessageType<MagicVault> {
    constructor() {
        super("c1.api.vault.v1.MagicVault", [
            { no: 1, name: "allowed_views", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "allow_unauthed_views", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.MagicVault
 */
export const MagicVault = new MagicVault$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vault$Type extends MessageType<Vault> {
    constructor() {
        super("c1.api.vault.v1.Vault", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "3", maxLen: "1024" } } } },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "8192" } } } },
            { no: 7, name: "credential_expiration_duration", kind: "message", T: () => Duration },
            { no: 100, name: "group_authz_vault", kind: "message", oneof: "vault", T: () => GroupAuthzVault },
            { no: 101, name: "magic_vault", kind: "message", oneof: "vault", T: () => MagicVault }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Vault" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.Vault
 */
export const Vault = new Vault$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceCreateRequest$Type extends MessageType<VaultServiceCreateRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "3", maxLen: "1024" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "8192" } } } },
            { no: 4, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 100, name: "group_authz_vault", kind: "message", oneof: "vault", T: () => GroupAuthzVault },
            { no: 101, name: "magic_vault", kind: "message", oneof: "vault", T: () => MagicVault }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceCreateRequest
 */
export const VaultServiceCreateRequest = new VaultServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceCreateResponse$Type extends MessageType<VaultServiceCreateResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceCreateResponse", [
            { no: 1, name: "vault", kind: "message", T: () => Vault }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceCreateResponse
 */
export const VaultServiceCreateResponse = new VaultServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetRequest$Type extends MessageType<VaultServiceGetRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetRequest
 */
export const VaultServiceGetRequest = new VaultServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetResponse$Type extends MessageType<VaultServiceGetResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetResponse", [
            { no: 1, name: "vault", kind: "message", T: () => Vault }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetResponse
 */
export const VaultServiceGetResponse = new VaultServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceDeleteRequest$Type extends MessageType<VaultServiceDeleteRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceDeleteRequest
 */
export const VaultServiceDeleteRequest = new VaultServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceDeleteResponse$Type extends MessageType<VaultServiceDeleteResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceDeleteResponse
 */
export const VaultServiceDeleteResponse = new VaultServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceUpdateRequest$Type extends MessageType<VaultServiceUpdateRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceUpdateRequest", [
            { no: 1, name: "vault", kind: "message", T: () => Vault },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceUpdateRequest
 */
export const VaultServiceUpdateRequest = new VaultServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceUpdateResponse$Type extends MessageType<VaultServiceUpdateResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceUpdateResponse", [
            { no: 1, name: "vault", kind: "message", T: () => Vault }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceUpdateResponse
 */
export const VaultServiceUpdateResponse = new VaultServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListRequest$Type extends MessageType<VaultServiceListRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListRequest
 */
export const VaultServiceListRequest = new VaultServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListResponse$Type extends MessageType<VaultServiceListResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Vault },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListResponse
 */
export const VaultServiceListResponse = new VaultServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListOwnersRequest$Type extends MessageType<VaultServiceListOwnersRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListOwnersRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListOwnersRequest
 */
export const VaultServiceListOwnersRequest = new VaultServiceListOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListOwnersResponse$Type extends MessageType<VaultServiceListOwnersResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListOwnersResponse
 */
export const VaultServiceListOwnersResponse = new VaultServiceListOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSetOwnersRequest$Type extends MessageType<VaultServiceSetOwnersRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSetOwnersRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSetOwnersRequest
 */
export const VaultServiceSetOwnersRequest = new VaultServiceSetOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSetOwnersResponse$Type extends MessageType<VaultServiceSetOwnersResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSetOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSetOwnersResponse
 */
export const VaultServiceSetOwnersResponse = new VaultServiceSetOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchRequest$Type extends MessageType<VaultServiceSearchRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VaultRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchRequest
 */
export const VaultServiceSearchRequest = new VaultServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchResponse$Type extends MessageType<VaultServiceSearchResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Vault },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchResponse
 */
export const VaultServiceSearchResponse = new VaultServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetUserCanViewVaultsRequest$Type extends MessageType<VaultServiceGetUserCanViewVaultsRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetUserCanViewVaultsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsRequest
 */
export const VaultServiceGetUserCanViewVaultsRequest = new VaultServiceGetUserCanViewVaultsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetUserCanViewVaultsResponse$Type extends MessageType<VaultServiceGetUserCanViewVaultsResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetUserCanViewVaultsResponse", [
            { no: 1, name: "has_any_vaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsResponse
 */
export const VaultServiceGetUserCanViewVaultsResponse = new VaultServiceGetUserCanViewVaultsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchVaultsForOwnerRequest$Type extends MessageType<VaultServiceSearchVaultsForOwnerRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchVaultsForOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerRequest
 */
export const VaultServiceSearchVaultsForOwnerRequest = new VaultServiceSearchVaultsForOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchVaultsForOwnerResponse$Type extends MessageType<VaultServiceSearchVaultsForOwnerResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchVaultsForOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Vault },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerResponse
 */
export const VaultServiceSearchVaultsForOwnerResponse = new VaultServiceSearchVaultsForOwnerResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.vault.v1.VaultService
 */
export const VaultService = new ServiceType("c1.api.vault.v1.VaultService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceListRequest, O: VaultServiceListResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/vaults/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Vault", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Vault" }] } }, I: VaultServiceGetRequest, O: VaultServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/vaults", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Vault" }], group: "Vault" }] } }, I: VaultServiceCreateRequest, O: VaultServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/vaults/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Vault" }], group: "Vault" }] } }, I: VaultServiceDeleteRequest, O: VaultServiceDeleteResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/vaults/{vault.id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Vault" }], group: "Vault" }] } }, I: VaultServiceUpdateRequest, O: VaultServiceUpdateResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceSearchRequest, O: VaultServiceSearchResponse },
    { name: "SearchVaultsForOwner", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceSearchVaultsForOwnerRequest, O: VaultServiceSearchVaultsForOwnerResponse },
    { name: "ListOwners", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceListOwnersRequest, O: VaultServiceListOwnersResponse },
    { name: "SetOwners", options: { "authz.method": { role: "EDITOR" } }, I: VaultServiceSetOwnersRequest, O: VaultServiceSetOwnersResponse },
    { name: "GetUserCanViewVaults", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceGetUserCanViewVaultsRequest, O: VaultServiceGetUserCanViewVaultsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.vault.v1.AppVaultBindingService
 */
export const AppVaultBindingService = new ServiceType("c1.api.vault.v1.AppVaultBindingService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: AppVaultBindingServiceCreateRequest, O: AppVaultBindingServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AppVaultBindingServiceDeleteRequest, O: AppVaultBindingServiceDeleteResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AppVaultBindingServiceListRequest, O: AppVaultBindingServiceListResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.vault.v1.VaultOpenerService
 */
export const VaultOpenerService = new ServiceType("c1.api.vault.v1.VaultOpenerService", [
    { name: "Open", options: { "authz.method": { role: "VIEWER" } }, I: VaultOpenerServiceOpenRequest, O: VaultOpenerServiceOpenResponse }
]);
